import {FC, KeyboardEvent, MouseEvent, ReactNode} from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {ModalCore, SystemModal} from "@pg-design/modal-module";

import {ModalConfirmLayout} from "./modal_layout/ModalConfirmLayout";
import {ModalConfirmLayoutCentered} from "./modal_layout/ModalConfirmLayoutCentered";
import {ModalEmptyLayout} from "./modal_layout/ModalEmptyLayout";
import {ModalFloatingActions} from "./modal_layout/ModalFloatingActions";
import {ModalInvestmentLeadLayout} from "./modal_layout/ModalInvestmentLeadLayout";
import {ModalPropertyLeadLayout} from "./modal_layout/ModalPropertyLeadLayout";
import {ModalRadioSurveyLayout} from "./modal_layout/ModalRadioSurveyLayout";
import {ModalSimpleSurveyLayout} from "./modal_layout/ModalSimpleSurveyLayout";
import {ModalTopBar} from "./modal_layout/ModalTopBar";

const DEFAULT_Z_INDEX = 100;

export interface IModalProps {
    children?: ReactNode;
    className?: string;
    closeButtonClassName?: string;
    closeTimeout?: number;
    dataTestId?: string;
    isOpen: boolean;
    modalRootId?: string;
    onAfterClose?: () => void;
    onAfterOpen?: () => void;
    onModalClose: (event: MouseEvent | KeyboardEvent) => void;
    overlayClassName?: string;
    shouldCloseOnOverlayClick?: boolean;
    showCloseButton?: boolean;
    variant?: "mobile_bottom_modal";
    zIndex?: number;
}

type ModalType = FC<IModalProps> & {
    FloatingActions: typeof ModalFloatingActions;
    TopBar: typeof ModalTopBar;
    Layout: {
        Confirm: typeof ModalConfirmLayout;
        ConfirmCentered: typeof ModalConfirmLayoutCentered;
        Empty: typeof ModalEmptyLayout;
        InvestmentLead: typeof ModalInvestmentLeadLayout;
        PropertyLead: typeof ModalPropertyLeadLayout;
        RadioSurvey: typeof ModalRadioSurveyLayout;
        SimpleSurvey: typeof ModalSimpleSurveyLayout;
    };
};

export const Modal: ModalType = (props: IModalProps) => {
    const {
        children,
        className,
        closeButtonClassName,
        closeTimeout,
        overlayClassName,
        dataTestId,
        isOpen,
        modalRootId,
        onAfterClose,
        onAfterOpen,
        onModalClose,
        shouldCloseOnOverlayClick,
        showCloseButton,
        variant,
        zIndex
    } = props;

    const resolvedZIndex = zIndex ?? DEFAULT_Z_INDEX;

    if (variant === "mobile_bottom_modal")
        return (
            <ModalCore
                className={cx(modalContentPresenceStyle, className)}
                contentClassName={mobileBottomModalContent}
                dataTestId={dataTestId}
                isOpen={isOpen}
                modalRootId={modalRootId}
                onModalClose={onModalClose}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                overlayClassName={cx(modalOverlayPresenceStyle, mobileBottomModalOverlay)}
                overlayStyle={{zIndex: resolvedZIndex}}
                showCloseButton={false}
            >
                <CloseIcon className={mobileBottomModalCloseIcon} size="2" wrapperSize="3.2" wrapperColor="var(--colors-white)" onClick={onModalClose} />

                {children}
            </ModalCore>
        );

    return (
        <SystemModal
            className={cx(modalContentPresenceStyle, className)}
            closeButtonClassName={closeButtonClassName}
            closeTimeout={closeTimeout}
            isOpen={isOpen}
            overlayClassName={cx(modalOverlayPresenceStyle, overlayClassName)}
            modalRootId={modalRootId}
            onAfterClose={onAfterClose}
            onAfterOpen={onAfterOpen}
            onModalClose={onModalClose}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            showCloseButton={showCloseButton}
            zIndex={resolvedZIndex}
        >
            {children}
        </SystemModal>
    );
};

Modal.FloatingActions = ModalFloatingActions;
Modal.TopBar = ModalTopBar;

Modal.Layout = {
    Confirm: ModalConfirmLayout,
    ConfirmCentered: ModalConfirmLayoutCentered,
    Empty: ModalEmptyLayout,
    InvestmentLead: ModalInvestmentLeadLayout,
    PropertyLead: ModalPropertyLeadLayout,
    RadioSurvey: ModalRadioSurveyLayout,
    SimpleSurvey: ModalSimpleSurveyLayout
};

const modalContentPresenceStyle = css({
    opacity: 0,
    transform: "translateY(0.8rem)",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 200ms cubic-bezier(0.4, 0, 0.2, 1)",

    "&.ReactModal__Content--after-open": {
        opacity: 1,
        transform: "translateY(0)"
    },

    "&.ReactModal__Content--before-close": {
        opacity: 0,
        transform: "translateY(0.8rem)"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transform: "none",
        transition: "none"
    }
});

const modalOverlayPresenceStyle = css({
    opacity: 0,
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)",

    "&.ReactModal__Overlay--after-open": {
        opacity: 1
    },

    "&.ReactModal__Overlay--before-close": {
        opacity: 0
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const mobileBottomModalContent = css({
    inset: "auto calc(var(--globals-baseUnit) * 1.5) calc(var(--globals-baseUnit) * -1.5) calc(var(--globals-baseUnit) * 1.5)",
    overflow: "visible"
});

const mobileBottomModalCloseIcon = css({
    position: "absolute",
    top: "-28px",
    right: "-28px",
    zIndex: DEFAULT_Z_INDEX
});

const mobileBottomModalOverlay = css({
    zIndex: DEFAULT_Z_INDEX
});
import {FC, KeyboardEvent, MouseEvent, ReactNode} from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {ModalCore, SystemModal} from "@pg-design/modal-module";

import {ModalConfirmLayout} from "./modal_layout/ModalConfirmLayout";
import {ModalConfirmLayoutCentered} from "./modal_layout/ModalConfirmLayoutCentered";
import {ModalEmptyLayout} from "./modal_layout/ModalEmptyLayout";
import {ModalFloatingActions} from "./modal_layout/ModalFloatingActions";
import {ModalInvestmentLeadLayout} from "./modal_layout/ModalInvestmentLeadLayout";
import {ModalPropertyLeadLayout} from "./modal_layout/ModalPropertyLeadLayout";
import {ModalRadioSurveyLayout} from "./modal_layout/ModalRadioSurveyLayout";
import {ModalSimpleSurveyLayout} from "./modal_layout/ModalSimpleSurveyLayout";
import {ModalTopBar} from "./modal_layout/ModalTopBar";

const DEFAULT_Z_INDEX = 100;

export interface IModalProps {
    children?: ReactNode;
    className?: string;
    closeButtonClassName?: string;
    closeTimeout?: number;
    dataTestId?: string;
    isOpen: boolean;
    modalRootId?: string;
    onAfterClose?: () => void;
    onAfterOpen?: () => void;
    onModalClose: (event: MouseEvent | KeyboardEvent) => void;
    overlayClassName?: string;
    shouldCloseOnOverlayClick?: boolean;
    showCloseButton?: boolean;
    variant?: "mobile_bottom_modal";
    zIndex?: number;
}

type ModalType = FC<IModalProps> & {
    FloatingActions: typeof ModalFloatingActions;
    TopBar: typeof ModalTopBar;
    Layout: {
        Confirm: typeof ModalConfirmLayout;
        ConfirmCentered: typeof ModalConfirmLayoutCentered;
        Empty: typeof ModalEmptyLayout;
        InvestmentLead: typeof ModalInvestmentLeadLayout;
        PropertyLead: typeof ModalPropertyLeadLayout;
        RadioSurvey: typeof ModalRadioSurveyLayout;
        SimpleSurvey: typeof ModalSimpleSurveyLayout;
    };
};

export const Modal: ModalType = (props: IModalProps) => {
    const {
        children,
        className,
        closeButtonClassName,
        closeTimeout,
        overlayClassName,
        dataTestId,
        isOpen,
        modalRootId,
        onAfterClose,
        onAfterOpen,
        onModalClose,
        shouldCloseOnOverlayClick,
        showCloseButton,
        variant,
        zIndex
    } = props;

    const resolvedZIndex = zIndex ?? DEFAULT_Z_INDEX;

    if (variant === "mobile_bottom_modal")
        return (
            <ModalCore
                className={cx(modalContentPresenceStyle, className)}
                contentClassName={mobileBottomModalContent}
                dataTestId={dataTestId}
                isOpen={isOpen}
                modalRootId={modalRootId}
                onModalClose={onModalClose}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                overlayClassName={cx(modalOverlayPresenceStyle, mobileBottomModalOverlay)}
                overlayStyle={{zIndex: resolvedZIndex}}
                showCloseButton={false}
            >
                <CloseIcon className={mobileBottomModalCloseIcon} size="2" wrapperSize="3.2" wrapperColor="var(--colors-white)" onClick={onModalClose} />

                {children}
            </ModalCore>
        );

    return (
        <SystemModal
            className={cx(modalContentPresenceStyle, className)}
            closeButtonClassName={closeButtonClassName}
            closeTimeout={closeTimeout}
            isOpen={isOpen}
            overlayClassName={cx(modalOverlayPresenceStyle, overlayClassName)}
            modalRootId={modalRootId}
            onAfterClose={onAfterClose}
            onAfterOpen={onAfterOpen}
            onModalClose={onModalClose}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            showCloseButton={showCloseButton}
            zIndex={resolvedZIndex}
        >
            {children}
        </SystemModal>
    );
};

Modal.FloatingActions = ModalFloatingActions;
Modal.TopBar = ModalTopBar;

Modal.Layout = {
    Confirm: ModalConfirmLayout,
    ConfirmCentered: ModalConfirmLayoutCentered,
    Empty: ModalEmptyLayout,
    InvestmentLead: ModalInvestmentLeadLayout,
    PropertyLead: ModalPropertyLeadLayout,
    RadioSurvey: ModalRadioSurveyLayout,
    SimpleSurvey: ModalSimpleSurveyLayout
};

const modalContentPresenceStyle = css({
    opacity: 0,
    transform: "translateY(0.8rem)",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 200ms cubic-bezier(0.4, 0, 0.2, 1)",

    "&.ReactModal__Content--after-open": {
        opacity: 1,
        transform: "translateY(0)"
    },

    "&.ReactModal__Content--before-close": {
        opacity: 0,
        transform: "translateY(0.8rem)"
    },

    "@media (prefers-reduced-motion: reduce)": {
        transform: "none",
        transition: "none"
    }
});

const modalOverlayPresenceStyle = css({
    opacity: 0,
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)",

    "&.ReactModal__Overlay--after-open": {
        opacity: 1
    },

    "&.ReactModal__Overlay--before-close": {
        opacity: 0
    },

    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const mobileBottomModalContent = css({
    inset: "auto calc(var(--globals-baseUnit) * 1.5) calc(var(--globals-baseUnit) * -1.5) calc(var(--globals-baseUnit) * 1.5)",
    overflow: "visible"
});

const mobileBottomModalCloseIcon = css({
    position: "absolute",
    top: "-28px",
    right: "-28px",
    zIndex: DEFAULT_Z_INDEX
});

const mobileBottomModalOverlay = css({
    zIndex: DEFAULT_Z_INDEX
});
